import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 16 16",
    }}
    viewBox="0 0 16 16"
    fill="#2c3e43"
    {...props}
  >
    <defs>
      <path id="SVGID_1_" d="M.1.1h15.7v15.8H.1z" />
    </defs>
    <clipPath id="SVGID_00000083089595656486089270000018405668455124812192_">
      <use
        xlinkHref="#SVGID_1_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000083089595656486089270000018405668455124812192_)",
      }}
    >
      <path
        d="M8 3.9c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4c0-2.1-1.8-4-4-4zm0 6.7c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6zM12.2 4.7c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9z"
        className="st1"
      />
      <path
        d="M15.8 4.8c0-.7-.1-1.3-.4-1.9C15 1.8 14.2 1 13.1.6c-.6-.2-1.3-.4-1.9-.4H4.8c-.7 0-1.3.1-1.9.4C1.8.9.9 1.8.5 2.8.3 3.4.2 4.1.2 4.7v6.4c0 .7.1 1.3.4 1.9.4 1.1 1.2 1.9 2.3 2.3.6.2 1.3.4 1.9.4h6.4c.7 0 1.3-.1 1.9-.4 1.1-.4 1.9-1.2 2.3-2.3.2-.6.4-1.3.4-1.9V7.9c.1-2 .1-2.3 0-3.1zm-1.4 6.4c0 .5-.1 1-.3 1.5-.3.7-.8 1.2-1.5 1.5-.5.2-1 .3-1.5.3H4.7c-.5 0-1-.1-1.5-.3-.7-.3-1.2-.8-1.5-1.5-.2-.5-.3-1-.3-1.5V4.8c0-.5.1-1 .3-1.5.3-.7.8-1.2 1.5-1.5.5-.2 1-.3 1.5-.3h6.4c.5 0 1 .1 1.5.3.7.3 1.2.8 1.5 1.5.2.5.3 1 .3 1.5v6.4z"
        className="st1"
      />
    </g>
  </svg>
)
export default SvgComponent